import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';

export default function AddPlane({ angleX, pos, animation, color }) {
  const refObj = useRef();
  useFrame((state, delta) => {
    if (animation) {
      if (refObj.current) refObj.current.rotation.z += delta * 0.1;
    }
  }); // call each Frame - similar as RequestAnimationFrame(update)

  return (
    <mesh
      ref={refObj}
      position={pos}
      scale={[20, 20, 1]}
      rotation-x={angleX}
      // receiveShadow
    >
      <planeGeometry widthSegments={10} heightSegments={5} />
      {/* <meshBasicMaterial
        color={color}
        // wireframe={otherSize ? true : false}
        wireframe
      /> */}
      <meshStandardMaterial color={color} />
    </mesh>
  );
}
